import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const points = [
  "Practical outpatient medical services",
  "Diagnostic support on site",
  "Orthopedic and pain-related care",
  "Medically supervised wellness services",
];

export default function IntroSection() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-content mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="About the clinic"
            title="Focused Care for Everyday Health Needs"
            description="Florida Family Clinic is a private outpatient medical practice in Miami. We provide practical medical services, diagnostic support, orthopedic care, pain-related treatment, and wellness services — all in one convenient setting."
          />
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <Reveal className="lg:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {points.map((point) => (
                <div
                  key={point}
                  className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-4"
                >
                  <span className="w-8 h-8 rounded-md bg-primary-100 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-primary-700" />
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{point}</span>
                </div>
              ))}
            </div>
            <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-600">
              Our aim is straightforward: offer patients clear information, convenient outpatient
              care, and a calm environment where questions can be discussed directly with the
              clinic. We do not make promises about outcomes — we focus on providing appropriate
              services and support based on each patient's individual needs.
            </p>
          </Reveal>

          <Reveal delay={120}>
            <div className="rounded-xl border border-background-200 bg-background-50 p-6">
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                A convenient outpatient option
              </h3>
              <ul className="mt-5 space-y-4">
                <li className="flex items-start gap-3">
                  <span className="w-8 h-8 rounded-md bg-accent-100 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-2-line text-accent-700" />
                  </span>
                  <span className="text-sm text-foreground-700">Located in Miami, Florida</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-8 h-8 rounded-md bg-accent-100 flex items-center justify-center shrink-0">
                    <i className="ri-layout-grid-line text-accent-700" />
                  </span>
                  <span className="text-sm text-foreground-700">
                    Multiple services through one clinic
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-8 h-8 rounded-md bg-accent-100 flex items-center justify-center shrink-0">
                    <i className="ri-chat-check-line text-accent-700" />
                  </span>
                  <span className="text-sm text-foreground-700">
                    Straightforward appointment inquiries
                  </span>
                </li>
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}